import { Controller } from "@hotwired/stimulus"

// Stimulus controller for opening/closing modals
export default class extends Controller {
  static targets = ["modal"]
  static values = {
    modalId: String
  }

  open(_event) {
    const modal = this._findModal()
    if (!modal) return
    if (typeof modal.showModal === "function") {
      modal.showModal()
    } else {
      modal.style.display = "block"
    }

    this._submitPreviewOnOpen(modal)
  }

  close(_event) {
    const modal = this._findModal()
    if (!modal) return
    if (typeof modal.close === "function") {
      modal.close()
    } else {
      modal.style.display = "none"
    }
  }

  // Close dialog after a Turbo-driven form inside the modal succeeds (e.g. bulk archive).
  closeAfterSuccessfulSubmit (event) {
    if (!event.detail.success) return
    this.close(event)
  }

  _findModal() {
    if (this.hasModalTarget) {
      return this.modalTarget
    } else if (this.hasModalIdValue) {
      return document.getElementById(this.modalIdValue)
    } else if (this.element.dataset.modalId) {
      return document.getElementById(this.element.dataset.modalId)
    } else {
      // Check for a turbo-frame with id 'modal' that has content
      const turboFrame = document.querySelector('turbo-frame#modal')
      if (turboFrame && turboFrame.innerHTML.trim() !== "") {
        return turboFrame.firstElementChild
      }
    }
    console.warn("Modal Controller: No modal target or id defined")
    return null
  }

  _submitPreviewOnOpen(modal) {
    const form = modal.querySelector('form[data-preview-on-open="true"]')
    if (!form || !form.checkValidity()) return

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
